import React, { useEffect, useState } from "react";
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

import Result from '../../../components/misc/Message/Result';
import { initPasswordReset } from "../services/password.service";
import { HttpStatusCode } from "axios";
import Spinner from "../../shared/components/Spinner";

interface IProps {
    close: Function,
    usuario: string
}

const BlanquearClave = (props: IProps) => {
    const [reset, setReset] = React.useState<'init' | 'reset' | 'error'>('init');
    const [errors, setErrors] = React.useState<string>('');
    const [loading, setLoading] = React.useState<boolean>(false);

    function onHide() {
        props.close();
    }

    const onAceptar: () => Promise<void> = async () => {
        setLoading(true);
        const { data, status } = await initPasswordReset(props.usuario);

        if (status != HttpStatusCode.Ok) {
            setReset('error');
            setLoading(false);
            return;
        }

        if (!data.success) {
            setReset('error');
            setErrors(data.error.message)
            setLoading(false);
            return;
        }

        setReset('reset');
        setLoading(false);
    }

    const footer = () => {
        return (
            <div className="d-flex justify-content-center">
                <Button label="Cancelar" icon="pi pi-times" onClick={() => onHide()} className="p-button-secondary" />
                <Button label="Aceptar" icon="pi pi-check" onClick={() => onAceptar()} />
            </div>
        );
    }

    return (
        <>
            <Dialog style={{width: '25vw', height: '25vh', justifyContent: 'center', alignContent: 'center', display: 'flex' }} visible={loading} modal={true} closable={false} onHide={() => { }}>
                <Spinner />
            </Dialog>
            {reset === 'reset' &&
                <Result
                    accept={props.close}
                    title="Ok"
                    message="¡Revisa tu casilla de correo electronico para continuar con el proceso de recuperación!"
                    redirect={false}
                    url=""
                    type="success" />}
            {reset === 'error' &&
                <Result
                    accept={props.close}
                    title="Atencion"
                    message={errors != null && errors != '' ? errors : "La contraseña no pudo ser blanqueada."}
                    redirect={false}
                    url=""
                    type="error" />
            }
            {reset === 'init' &&
                <Dialog
                    header="Recuperar Contraseña"
                    visible={true}
                    modal={true}
                    onHide={() => onHide()}
                    footer={() => footer()}
                    className="text-left">
                    <p className="text-center">{`Al aceptar se le enviara un email para blanquear su contraseña. \n ¿Desea continuar?`}</p>
                </Dialog>}
        </>

    );
}
export default BlanquearClave;